module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "min-h-screen w-full flex items-center justify-center p-4 text-white",
    staticStyle: {
      "background": "linear-gradient(to bottom, #2972db 0%, #163D75 100%)"
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "w-full max-w-sm flex flex-col items-center gap-6"
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('span', {
    staticClass: "logo hidden"
  }), _vm._v(" "), _c('img', {
    staticClass: "h-16 w-auto select-none",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "logo fi360"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: " flex flex-col items-center"
  }, [_c('radial-progress-bar', {
    attrs: {
      "diameter": 220,
      "animate-speed": 80,
      "completed-steps": _vm.completedSteps,
      "total-steps": _vm.totalSteps,
      "start-color": _vm.startColor,
      "stop-color": _vm.stopColor,
      "inner-stroke-color": "#ffffff"
    }
  }, [_c('p', {
    staticClass: "info-dl text-center text-sm mt-4 mb-2"
  }, [_vm._v("\n          " + _vm._s(_vm.txtSync) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex items-center justify-center gap-2 loader-dots",
    attrs: {
      "id": "loader-2"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-xs text-white/80 text-center",
    attrs: {
      "id": "textInfo"
    }
  }, [_vm._v("\n          Merci de patienter\n        ")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cddf195","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Synchro.vue
// module id = 1002
// module chunks = 0